

export function NotFound(){
    return (<p>NOT FOUND</p>);
}